import { Avatar, Space, Typography, Dropdown } from "antd";
import React, { useState } from "react";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";

//
//component
//redux
//selector
import { emailSelector } from "store/user/auth/user_auth.selector";
//actions
import { logOut as logoutBailiff } from "store/bailiff/auth/bailiff_auth.action";
import { logOut as logoutUser } from "store/user/auth/user_auth.action";
//utils
//hook
//str
import "./header_user.css";

const HeaderUser = () => {
  // -------------------------- VAR -----------------------------

  // -------------------------- STATE ---------------------------
  const [open, setOpen] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const email = useSelector(emailSelector);
  const name = email?.split("@")?.[0] || "Chưa có tên";

  // -------------------------- FUNCTION ------------------------
  const handleLogout = () => {
    dispatch(logoutBailiff());
    dispatch(logoutUser());
  };

  const handleChange = (value) => {
    setOpen(value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const items = [
    {
      key: "1",
      label: (
        <Space onClick={handleLogout}>
          <LogoutOutlined />
          <Typography.Text>Đăng Xuất</Typography.Text>
        </Space>
      ),
    },
  ];

  // -------------------------- MAIN ----------------------------
  return (
    <Dropdown
      menu={{ items }}
      placement="bottom"
      trigger={["hover"]}
      open={open}
      onOpenChange={handleChange}
      className="logout-dropdown"
    >
      <div
        style={{
          width: 150,
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <Avatar size="small" icon={<UserOutlined />} />
        <Typography.Text
          style={{ marginLeft: 10, width: 100 }}
          ellipsis={{ rows: 1 }}
          type="secondary"
        >
          {name}
        </Typography.Text>
      </div>
    </Dropdown>
  );
};
export default HeaderUser;
